
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"9.004"}}),_c('path',{attrs:{"d":"M7.685 7.685A2.181 2.181 0 019.9 5.998 2.137 2.137 0 0112.15 8C12.15 9.504 10 10 10 11M10.125 13.752a.125.125 0 11-.125-.126M10 13.627c.07 0 .125.055.125.125"}})])
          )
        }
      }
    